import { render, staticRenderFns } from "./service-locations-general-card.vue?vue&type=template&id=184d06d2&scoped=true&"
import script from "./service-locations-general-card.vue?vue&type=script&lang=js&"
export * from "./service-locations-general-card.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-general-card.vue?vue&type=style&index=0&id=184d06d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d06d2",
  null
  
)

export default component.exports